import type { ImportSource } from '@system-atlas/shared';
import azure from './scripts/export-azure-users.ps1?raw';
import hyperv from './scripts/export-hyperv-vms.ps1?raw';
import vmware from './scripts/export-vmware-vms.ps1?raw';
import hypervStorage from './scripts/export-hyperv-storage.ps1?raw';

/** PowerShell-Export-Skript je Import-Quelle (im Import-Dialog kopierbar). */
export const IMPORT_SCRIPTS: Record<ImportSource, string> = {
  'azure-users': azure,
  'hyperv-vms': hyperv,
  'vmware-vms': vmware,
  'hyperv-storage': hypervStorage,
};
